import React from 'react';
import Hero from '../components/sections/Hero';
import Mission from '../components/sections/Mission';
import Pets from '../components/sections/Pets';
import Help from '../components/sections/Help';
import Place from '../components/sections/Place';
import MarqueeStrip from '../components/MarqueeStrip';
import HighlightDeck from '../components/highlight/HighlightDeck';
import { HERO_COVER, TICKER_NAMES } from '../data/pets';
import { SITE } from '../data/site';
import { getActiveHighlights } from '../data/highlights';
import { usePublicPets } from '../hooks/usePublicPets';
import SEO from '../components/SEO';
import '../styles/Home.css';

const Home: React.FC = () => {
  const { featured, catalog, ticker, totalElements, loading, isEmpty } =
    usePublicPets();

  // When the API is unreachable / empty, fall back to the editorial ticker
  // so the design's running strip never reads as a build error.
  const tickerNames = ticker.length > 0 ? ticker : TICKER_NAMES;
  const highlights = getActiveHighlights();

  return (
    <div className="home">
      <SEO
        title="Patinhas Sem Lar — Adoção de Cães e Gatos em Silvalde, Espinho"
        description="Pequeno abrigo em Silvalde, Espinho. Acolhemos cães e gatos com tempo e entregamos com calma. Conheça os animais para adoção, ajude com donativos ou acolhimento temporário."
        path="/"
      />
      <Hero coverPet={HERO_COVER} />
      <MarqueeStrip names={tickerNames} tail="— à espera de nome ao telefone" />
      {highlights.length > 0 && <HighlightDeck highlights={highlights} />}
      <Mission />
      <Pets
        featured={featured}
        catalog={catalog}
        total={totalElements}
        loading={loading}
        isEmpty={isEmpty}
      />
      <Help donation={SITE.donation} />
      <Place
        locations={SITE.place.locations}
        footnote={SITE.place.footnote}
      />
    </div>
  );
};

export default Home;
